var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotaldoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#7C4095"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5002 35.8333H33.5002M26.5002 32.3333H33.5002M38.1664 26.5H33.033C32.3796 26.5 32.0533 26.5 31.8037 26.3728C31.5842 26.261 31.4058 26.0825 31.294 25.863C31.1668 25.6135 31.1668 25.2867 31.1668 24.6333V19.5M38.1668 36.7667V27.263C38.1668 26.7222 38.1671 26.4518 38.1087 26.1959C38.057 25.9689 37.9718 25.7509 37.8555 25.5491C37.7244 25.3217 37.5406 25.1233 37.1732 24.7265L33.4421 20.6969C33.0337 20.2559 32.8294 20.0354 32.5864 19.8773C32.3711 19.7373 32.1336 19.6337 31.8845 19.5709C31.6035 19.5 31.3036 19.5 30.7026 19.5H25.5671C24.2603 19.5 23.6064 19.5 23.1073 19.7543C22.6682 19.978 22.3115 20.335 22.0878 20.774C21.8335 21.2732 21.8335 21.9266 21.8335 23.2333V36.7667C21.8335 38.0735 21.8335 38.7268 22.0878 39.226C22.3115 39.665 22.6682 40.0219 23.1073 40.2456C23.6064 40.5 24.2603 40.5 25.5671 40.5H34.4337C35.7405 40.5 36.3935 40.5 36.8926 40.2456C37.3316 40.0219 37.6891 39.665 37.9128 39.226C38.1671 38.7268 38.1668 38.0735 38.1668 36.7667Z",
    stroke: "#7C4095",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotaldoc);
export default __webpack_public_path__ + "static/media/total doc.c06b616e1b53d3210281182369640960.svg";
export { ForwardRef as ReactComponent };